import React from "react";
import { View, Text, Image, StyleSheet, Pressable } from "react-native";

function CatalogeCourseCard({ title, imageUrl, progress = 0, onPress }) {
  const statusText = progress === 0 ? "Not Started" : progress >= 100 ? "Complete" : "In Progress";

  return (
    <View style={styles.card}>
      <Image source={{ uri: imageUrl }} style={styles.image} />
      <View style={styles.content}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.status}>{statusText}</Text>
        <View style={styles.progressBarBackground}>
          <View style={[styles.progressBarFill, { width: `${progress}%` }]} />
        </View>
        <Pressable style={styles.button} onPress={onPress}>
          <Text style={styles.buttonText}>Continue Course</Text>
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    width: 400,
    flexGrow: 1,
    alignSelf: "center",
    borderRadius: 16,
    overflow: "hidden",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOpacity: 0.1,
    shadowRadius: 6,
    borderColor: "#EAECF0",
    borderWidth: 1,
  },
  image: {
    width: "100%",
    height: 184,
    resizeMode: "cover",
  },
  content: {
    gap: 12,
    padding: 24,
  },
  title: {
    fontWeight: "bold",
    fontSize: 16,
    color: "#101828",
  },
  status: {
    color: "#667085",
    marginTop: 4,
  },
  progressBarBackground: {
    height: 6,
    backgroundColor: "#EAECF0",
    borderRadius: 3,
    marginTop: 8,
    overflow: "hidden",
  },
  progressBarFill: {
    height: 6,
    backgroundColor: "#3E68FE",
    borderRadius: 3,
  },
  button: {
    marginTop: 12,
    backgroundColor: "#EEF4FF",
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 8,
    alignSelf: "flex-start",
  },
  buttonText: {
    color: "#3E68FE",
    fontWeight: "600",
  },
});

export default CatalogeCourseCard;
